<script setup lang="ts">
import { isOfficeAddinHost } from '@/office/utils';
</script>

<template>
  <!-- The bottom-right corner where background-task panels live (folder-zip
       downloads, demo seed). Panels stack newest-under-oldest with a 12px gap
       and share one right edge. Naive has no viewport-pinning primitive, so
       the fixed positioning is the sanctioned CSS exception (see <style>). -->
  <div class="gaia-corner-stack" :class="{ office: isOfficeAddinHost() }">
    <n-flex vertical :size="12" align="end">
      <slot />
    </n-flex>
  </div>
</template>

<style scoped>
/* Z ladder: 1000 sits above page content and below naive modals (~2000), the
   tour overlay (3500) and the toast stack (6000). The office variant clears
   the add-in's fixed bottom tab bar. */
.gaia-corner-stack {
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 1000;
}

.gaia-corner-stack.office {
  bottom: 60px;
}
</style>
